import { FC, useState } from 'react'
import mclasses from '@pages/Admin/CRM/styles/modal.module.css'
import Button from '@UI/New/Button'
import SelectLead from './SelectLead'
import { crmApi } from '@/api'
import { isError } from '@/helpers/checkQuery'
import { useAddAlert } from '@/hooks/useAddAlert'

interface BindLeadBlockProps {
  studentId: number
  onSuccess: () => void
}

const BindLeadBlock: FC<BindLeadBlockProps> = ({ studentId, onSuccess }) => {
  const addAlert = useAddAlert()
  const [selectedLead, setSelectedLead] = useState<number | null>(null)

  const handleSubmit = () => {
    if (!selectedLead) {
      addAlert({
        title: 'Ошибка',
        text: 'Ошибка не выбран лид',
        type: 'error',
      })
      return
    }

    crmApi
      .bindingStudAccount({
        lead_id: selectedLead,
        user_id: studentId,
      })
      .then((res) => {
        if (isError(res)) throw new Error()
        addAlert({
          title: 'Успешно',
          text: `Успешно создан и привязан лид`,
          type: 'success',
        })
        onSuccess()
      })
      .catch((error) => {
        addAlert({
          title: 'Ошибка',
          text: 'Ошибка привязки карточки лида',
          type: 'error',
        })
      })
  }

  return (
    <div className={mclasses.formWrapper}>
      <div>
        <p className={mclasses.label}>Выбрать личный кабинет лида</p>
        <SelectLead
          value={selectedLead}
          onChange={(val) => setSelectedLead(val)}
        />
        <p className={mclasses.label}>
          * отображаются только не привязанные лиды
        </p>
      </div>
      <div className={mclasses.actions}>
        <Button
          className={mclasses.marginLeftAuto}
          disabled={!selectedLead}
          onClick={handleSubmit}
        >
          Добавить
        </Button>
      </div>
    </div>
  )
}

export default BindLeadBlock
